import { Controller } from '@hotwired/stimulus'

export default class GoogleFirebaseAnalyticsSetupController extends Controller {
  static values = {
    'userId': String,
  }

  async connect() {
    const onMobile = await this.onMobile();
    if (!onMobile) return;

    this.setup();
  }

  setup = async () => {
    const acceptedAnalytics = Cookiebot.consent.statistics;
    Median.firebaseAnalytics.setConsent({'analyticsStorage': acceptedAnalytics});
    Median.firebaseAnalytics.event.collection({'enabled': acceptedAnalytics});
    Median.firebaseAnalytics.event.setUser({'ID': this.userIdValue});
  }

  // async connect() {
  //   const onMobile = await this.onMobile();
  //   if (!onMobile) return;

  //   this.setup();
  // }

  // setup() {
  //   window.addEventListener("CookiebotOnConsentReady", () => {
  //     try {
  //       const acceptedAnalytics = Cookiebot.consent.statistics;
  //       Median.firebaseAnalytics.setConsent({"analyticsStorage": acceptedAnalytics});
  //       Median.firebaseAnalytics.event.collection({"enabled": acceptedAnalytics});
  //       Median.firebaseAnalytics.event.setUser({"ID": this.userIdValue});
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   });
  // }

  // async onMobile() {
  //   const platform = await Median.getPlatform(); // "ios" | "android" | "web"
  //   return platform === "ios" || platform === "android";
  // }
}
